{
  "name": "paydone-userpanel",
  "version": "3.4.94",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "build:dev": "ng build --configuration development --base-href /",
    "build:test": "ng build --configuration test --base-href /",
    "build:stage": "ng build --configuration stage --base-href /",
    "build:prod": "ng build --configuration production --base-href /",
    "bundle-report": "ng build --configuration production --stats-json && webpack-bundle-analyzer dist/tc/stats.json",
    "test": "ng test",
    "lint": "ng lint",
    "cy:open": "npx cypress open",
    "cy:run": "npx cypress run",
    "cy:verify": "npx cypress run --spec cypress/e2e/basic.cy.ts"
  },
  "private": true,
  "dependencies": {
    "@angular-eslint/builder": "^21.0.1",
    "@angular/animations": "^21.0.0",
    "@angular/cdk": "21.0.0",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/material": "21.0.0",
    "@angular/material-moment-adapter": "^21.0.0",
    "@angular/platform-browser": "^21.0.0",
    "@angular/platform-browser-dynamic": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@ngrx/operators": "^20.1.0",
    "@ngrx/signals": "^20.1.0",
    "@sumsub/websdk": "^2.0.1",
    "@tailwindcss/postcss": "^4.0.13",
    "angularx-qrcode": "^18.0.1",
    "chart.js": "^4.4.7",
    "flag-icons": "^7.2.3",
    "jalali-moment": "^3.3.11",
    "libphonenumber-js": "^1.11.15",
    "ng-recaptcha": "^13.2.1",
    "ngx-exporter-material": "^1.0.6",
    "ngx-toastr": "^19.1.0",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.0.13",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^21.0.1",
    "@angular-eslint/eslint-plugin-template": "^21.0.1",
    "@angular-eslint/schematics": "^21.0.1",
    "@angular-eslint/template-parser": "^21.0.1",
    "@angular/build": "^21.0.0",
    "@angular/cli": "^21.0.0",
    "@angular/compiler-cli": "^21.0.0",
    "@tailwindcss/typography": "^0.5.16",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~5.1.0",
    "cypress": "^14.5.2",
    "eslint": "9.26.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.3",
    "prettier": "^3.2.4",
    "prettier-eslint": "^16.3.0",
    "pretty-quick": "^4.0.0",
    "typescript": "~5.9.3"
  }
}
